
/* BeamDeals DEV v2.0 JS
   Tracking helper and safe UI behaviors.
*/
(function() {
  function pushLeadEvent(eventName, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: eventName || 'beamdeals_lead_interaction',
      source: 'beamdeals_dev_v2',
      timestamp: new Date().toISOString()
    }, detail || {}));
  }

  document.addEventListener('click', function(e) {
    var el = e.target.closest('[data-bd2-track]');
    if (!el) return;
    pushLeadEvent(el.getAttribute('data-bd2-track'), {
      form_type: el.getAttribute('data-bd2-form-type') || '',
      product_handle: el.getAttribute('data-bd2-product') || '',
      cta_label: (el.textContent || '').trim()
    });
  });

  document.addEventListener('click', function(e) {
    var anchor = e.target.closest('[data-bd2-scroll]');
    if (!anchor) return;
    var target = document.querySelector(anchor.getAttribute('data-bd2-scroll'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  document.addEventListener('DOMContentLoaded', function() {
    var gate = document.querySelector('[data-bd2-b2b-gate]');
    if (!gate) return;

    var storageKey = gate.getAttribute('data-storage-key') || 'beamdeals_b2b_confirmed_v1';
    var rememberDays = Number(gate.getAttribute('data-remember-days') || 30);
    var stored = localStorage.getItem(storageKey);
    if (stored) {
      try {
        var payload = JSON.parse(stored);
        if (payload.expires && payload.expires > Date.now()) return;
      } catch(e) {}
    }

    gate.classList.add('is-active');

    var btn = gate.querySelector('[data-bd2-b2b-confirm]');
    var check = gate.querySelector('[data-bd2-b2b-checkbox]');
    if (btn) {
      btn.addEventListener('click', function() {
        if (check && !check.checked) {
          check.focus();
          gate.classList.add('bd2-b2b-gate--needs-check');
          return;
        }
        var expires = Date.now() + rememberDays * 24 * 60 * 60 * 1000;
        localStorage.setItem(storageKey, JSON.stringify({ confirmed: true, expires: expires }));
        gate.classList.remove('is-active');
        pushLeadEvent('beamdeals_b2b_confirmed', { form_type: 'b2b_gate' });
      });
    }
  });

  window.BeamDealsV2 = window.BeamDealsV2 || {};
  window.BeamDealsV2.pushLeadEvent = pushLeadEvent;
})();
